import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatNull, formatDate, isDatePastInMoscow } from '../../../Utils/GlobalUtils';

import Modal from '../../Modal';
import EditTK from './Modals/EditTK';

const TKPanel = ({ userId }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-user-tk?user_id=${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, userId]);

    const [isEditModal, setIsEditModal] = React.useState(false);

    const [isShowSec, setIsShowSec] = React.useState(false);


    return (
        <>
            <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
                <EditTK userId={userId} onSuccess={() => setReload(true)} />
            </Modal>
            
            <div className='panel linksPanel'>
                <h3>Информация о ТК</h3>
                <p>Серия и номер: {formatNull(formInfo.TK)}</p>
                <p>Дата выдачи: {formatNull(formatDate(formInfo.TK_date))}</p>
                {/* <p>Скан документа: {isShowSec ? formatNull(formInfo.admission_form) : <a className='aWithLink' onClick={() => setIsShowSec(true)}>Нажмите, чтобы увидеть</a>}</p> */}
                <button type='button' className='tableButton' onClick={() => setIsEditModal(true)}>Указать данные ТК</button>
            </div>
        </>
    )
}

export default TKPanel;